module.exports = __webpack_public_path__ + "img/cardiology.8ae0390b.svg";